<template>
  <v-layout row wrap justify-center id="presecription">
    <v-btn
      style="position: absolute; top:-35px; right: 20px;"
      @click="print"
      fab
      dark
      small
      color="primary"
      class="hidden-print-only"
    >
      <v-icon>mdi-printer</v-icon>
    </v-btn>

    <v-flex xs12 class="prec-top"></v-flex>

    <v-flex xs12 v-if="prescription.patient" class="prec-header">
      <v-layout row wrap >
        <div class="flex xs12 d-flex prec-name">
           <div id="patient"> <strong>Patient:</strong> {{prescription.patient.name}} </div>
           <div  id="age" > <strong>Age:</strong> {{prescription.patient.age}} </div>
           <div id="gender" > <strong>Gender:</strong> {{prescription.patient.gender}} </div>
           <div id="date"> <strong>Date:</strong> {{prescription.patient.created_at | moment('YYYY-MM-DD')}} </div>
        </div> 
        <v-flex xs12  class="prec-diagnoses">
          <strong>Diagnoses:</strong>
          <span class="ml-2">{{prescription.diagnoses}}</span>
        </v-flex>
      </v-layout>
    </v-flex>

    <!-- table -->
    <v-flex xs12 class="mt-3 prec-table">
      <v-data-table ref="tbl" class="printTable" :headers="headers" :items="prescription.drugs" hide-actions>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.route }}</td>
          <td>{{ props.item.duration }}</td>
          <td>{{ props.item.usage }}</td>
          <td>{{ props.item.quantity }}</td>
          <td>{{ props.item.type }}</td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  layout: "print",
  data() {
    return {
      headers: [
        { text: "Name", value: "name", sortable: false },
        { text: "Route", value: "route", sortable: false },
        {
          text: "Duration",
          value: "duration",
          sortable: false
        },
        { text: "Usage", value: "usage", sortable: false },
        { text: "Quantity", value: "quantity", sortable: false },
        { text: "Type", value: "type", sortable: false }
      ]
    };
  },
  computed: {
    prescription() {
      return this.$store.getters["doctors/prescription"];
    }
  },
  methods: {
    print() {
      window.print();
    }
  },
  mounted() {
    setTimeout(() => {
      window.print();
    }, 500);
  }
};
</script>

<style lang="css">
.printTable th {
  font-weight: bold !important;
  color: black !important;
}

@media print {
  #presecription{
    max-height: 290cm !important;
  }
}

</style>